/* file description */

import { compose } from '@cui/corteza-js';
import { message } from 'antd';
import { useEffect, useState } from 'react';

import { ModuleInfo } from '@/common/model-apis/type';
import type { UseXFModule } from './type';
import { getAssetModuleByRequest } from '@/common/asset-apis/getAssetModuleByRequest';

export const useModule: UseXFModule = ({ moduleID, namespaceID, FetchAPI, assetModuleInfo }) => {
  const [moduleInfo, setModuleInfo] = useState<ModuleInfo>({});
  useEffect(() => {
    getAssetModuleByRequest({ FetchAPI, namespaceID, moduleID, assetModuleInfo })
      ?.then((res) => {
        setModuleInfo(res);
      })
      .catch((error) => {
        message.error(error.message || error.msg || `加载module失败，moduleID: ${moduleID}`);
      });
  }, [assetModuleInfo, moduleID]);
  return {
    moduleInfo,
  };
};
